function setQrCode(state, code) {
  state.qrCode = code
}

export default {
  setQrCode,
}



// WEBPACK FOOTER //
// ./src/store/modules/mfa/mfa.mutations.js